// extracted by mini-css-extract-plugin
module.exports = {"root":"Employee_root__vJcnS","item":"Employee_item__2ptGq","photo":"Employee_photo__2UJH9"};